class ManageLayerOwner {
	static fromMap(data, list){
		let inst = new ManageLayerOwner(list);
		inst._name = data.name;

		return inst;
	}

	static fromListArray(data, list) {
		let inst = new ManageLayerOwner(list);
		inst._id = data.shift();
		inst._type = data.shift();
		inst._name = data.shift();

		return inst;
	}

	constructor(list) {
		this._list = list;
		this._id;
		this._type;
		this._name;

		this.rowCount = 0;
	}

	get id() {return this._id;}
	get elem() {
		if (!this._elem) this.buildElem();
		return this._elem;
	}
	
	buildElem() {
		this._elem = UI.div('norm', [
			this.header = UI.div('flex p-4 w-full items-center justify-between [&+div]:grid-rows-[1fr]', [
				UI.btn('', [
					UI.span(null, this._name),
				]),
			], {
				'click': _ => {
					this.header.classList.replace('[&+div]:grid-rows-[1fr]', '[&+div]:grid-rows-[0fr]');
				}
			}),
			this._rows = UI.div()
		]);
		this.update();
	}

	addLayer(layer) {
		this._rows.appendChild(layer.elem);
		this.rowCount++;
		this.update();
	}

	removeLayer(layer) {
		this._rows.removeChild(layer.elem);
		this.rowCount--;
		this.update();
	}

	update() {
		state(this._elem, this.rowCount ? 'norm' : 'hide');
	}
}
